import { dataProps, 
        itemListProps } from './properties'

export const setProductionItemIssueList = (state, payload) => {
    state.list = payload
}    

export const setProductionItemIssueData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    } else if(payload.copy) {
        state.props.item_list.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const setProductionItemIssueID = (state, payload) => {
    state.props.id = payload.id    
    state.props.challan_number = payload.challan_number
}

export const addNewProductionItemIssueItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('inventory_item_id_'+(key-1)).focus()
    }, 300);

}

export const removeProductionItemIssueItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setProductionItemIssueProductionDetail = (state, payload) => {
    state.props.production_id = payload.production_id
    state.props.work_order_number = payload.work_order_number    
}

export const resetProductionItemIssueData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/productionItemIssue/mutations.js